import { onMount, onDestroy, onView } from "@/modules/_";
import gsap from "@lib/gsap";
import { Scroll } from "@lib/scroll";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const textBlocks = element.querySelectorAll(".rich-text-block h1");

  gsap.set(textBlocks, {
    opacity: 0,
  });

  onMount(() => {
    gsap.set(textBlocks, {
      opacity: 1,
    });

    gsap.from(textBlocks, {
      yPercent: -100,
      duration: 0.6,
      ease: "power1",
      stagger: 0.2,
    });

    Scroll.on("scroll", () => {
      if (Scroll.actualScroll > 20) {
        gsap.to(element, {
          opacity: 0,
          duration: 0.6,
          ease: "power1",
        });
      } else {
        gsap.to(element, {
          opacity: 1,
          duration: 0.6,
          ease: "power1",
        });
      }
    });
  });
}
